// FDI tooth numbering tables.
// Convention: rows are listed as the dental "you're facing the patient" view —
// upper jaw on top, lower jaw on bottom; patient's RIGHT is on the chart's LEFT.

// Adult (permanent) teeth — 32
//   Quadrant 1 = upper-right, 2 = upper-left, 3 = lower-left, 4 = lower-right
//   Within each quadrant: 1 = central incisor → 8 = wisdom tooth (third molar)
export const ADULT_UPPER_RIGHT = ['18', '17', '16', '15', '14', '13', '12', '11']
export const ADULT_UPPER_LEFT  = ['21', '22', '23', '24', '25', '26', '27', '28']
export const ADULT_LOWER_RIGHT = ['48', '47', '46', '45', '44', '43', '42', '41']
export const ADULT_LOWER_LEFT  = ['31', '32', '33', '34', '35', '36', '37', '38']

// Pedo (primary) teeth — 20
//   Quadrant 5 = upper-right, 6 = upper-left, 7 = lower-left, 8 = lower-right
//   Within each quadrant: 1 = central incisor → 5 = second molar
export const PEDO_UPPER_RIGHT = ['55', '54', '53', '52', '51']
export const PEDO_UPPER_LEFT  = ['61', '62', '63', '64', '65']
export const PEDO_LOWER_RIGHT = ['85', '84', '83', '82', '81']
export const PEDO_LOWER_LEFT  = ['71', '72', '73', '74', '75']

export const ALL_ADULT = [
  ...ADULT_UPPER_RIGHT, ...ADULT_UPPER_LEFT,
  ...ADULT_LOWER_RIGHT, ...ADULT_LOWER_LEFT,
]
export const ALL_PEDO = [
  ...PEDO_UPPER_RIGHT, ...PEDO_UPPER_LEFT,
  ...PEDO_LOWER_RIGHT, ...PEDO_LOWER_LEFT,
]

/**
 * Categorize a tooth number by FDI quadrant prefix.
 * Returns 'adult' for quadrants 1-4, 'pedo' for 5-8, null otherwise.
 */
export function classifyTooth(num) {
  const s = String(num)
  const q = s.charAt(0)
  if (['1', '2', '3', '4'].includes(q) && /^[1-4][1-8]$/.test(s)) return 'adult'
  if (['5', '6', '7', '8'].includes(q) && /^[5-8][1-5]$/.test(s)) return 'pedo'
  return null
}
